/**
 * Generated by orval v6.7.1 🍺
 * Do not edit manually.
 * NFD Management Service
 * Service for querying and managing NFDs
 * OpenAPI spec version: 1.0
 */
import { customAxios } from './mutator/custom-axios'
export type NfdUpdateImageParams = { wantTxn?: boolean }

export type NfdSuggestView = 'brief' | 'full'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdSuggestView = {
  brief: 'brief' as NfdSuggestView,
  full: 'full' as NfdSuggestView
}

export type NfdSuggestParams = { limit?: number; view?: NfdSuggestView }

export type NfdBrowseView = 'tiny' | 'brief' | 'full'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseView = {
  tiny: 'tiny' as NfdBrowseView,
  brief: 'brief' as NfdBrowseView,
  full: 'full' as NfdBrowseView
}

export type NfdBrowseSort =
  | 'createdDesc'
  | 'soldDesc'
  | 'priceAsc'
  | 'priceDesc'
  | 'highestSaleDesc'
  | 'saleTypeAsc'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseSort = {
  createdDesc: 'createdDesc' as NfdBrowseSort,
  soldDesc: 'soldDesc' as NfdBrowseSort,
  priceAsc: 'priceAsc' as NfdBrowseSort,
  priceDesc: 'priceDesc' as NfdBrowseSort,
  highestSaleDesc: 'highestSaleDesc' as NfdBrowseSort,
  saleTypeAsc: 'saleTypeAsc' as NfdBrowseSort
}

export type NfdBrowseTraitsItem = 'emoji'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseTraitsItem = {
  emoji: 'emoji' as NfdBrowseTraitsItem
}

export type NfdBrowseLengthItem =
  | '1_letters'
  | '2_letters'
  | '3_letters'
  | '4_letters'
  | '5_letters'
  | '6_letters'
  | '7_letters'
  | '8_letters'
  | '9_letters'
  | '10+_letters'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseLengthItem = {
  '1_letters': '1_letters' as NfdBrowseLengthItem,
  '2_letters': '2_letters' as NfdBrowseLengthItem,
  '3_letters': '3_letters' as NfdBrowseLengthItem,
  '4_letters': '4_letters' as NfdBrowseLengthItem,
  '5_letters': '5_letters' as NfdBrowseLengthItem,
  '6_letters': '6_letters' as NfdBrowseLengthItem,
  '7_letters': '7_letters' as NfdBrowseLengthItem,
  '8_letters': '8_letters' as NfdBrowseLengthItem,
  '9_letters': '9_letters' as NfdBrowseLengthItem,
  '10_letters': '10+_letters' as NfdBrowseLengthItem
}

export type NfdBrowseStateItem = 'minting' | 'forSale' | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseStateItem = {
  minting: 'minting' as NfdBrowseStateItem,
  forSale: 'forSale' as NfdBrowseStateItem,
  owned: 'owned' as NfdBrowseStateItem
}

export type NfdBrowseSaleTypeItem = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseSaleTypeItem = {
  auction: 'auction' as NfdBrowseSaleTypeItem,
  buyItNow: 'buyItNow' as NfdBrowseSaleTypeItem
}

export type NfdBrowseCategoryItem = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdBrowseCategoryItem = {
  curated: 'curated' as NfdBrowseCategoryItem,
  premium: 'premium' as NfdBrowseCategoryItem,
  common: 'common' as NfdBrowseCategoryItem
}

export type NfdBrowseParams = {
  name?: string
  category?: NfdBrowseCategoryItem[]
  saleType?: NfdBrowseSaleTypeItem[]
  state?: NfdBrowseStateItem[]
  length?: NfdBrowseLengthItem[]
  traits?: NfdBrowseTraitsItem[]
  minPrice?: number
  maxPrice?: number
  limit?: number
  offset?: number
  sort?: NfdBrowseSort
  view?: NfdBrowseView
}

export type NfdGetOpenAuctionsParams = { name?: string; startingSoon?: boolean }

export type NfdAnalyticsSort = 'timeDesc' | 'priceAsc' | 'priceDesc'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsSort = {
  timeDesc: 'timeDesc' as NfdAnalyticsSort,
  priceAsc: 'priceAsc' as NfdAnalyticsSort,
  priceDesc: 'priceDesc' as NfdAnalyticsSort
}

export type NfdAnalyticsTraitsItem = 'emoji'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsTraitsItem = {
  emoji: 'emoji' as NfdAnalyticsTraitsItem
}

export type NfdAnalyticsLengthItem =
  | '1_letters'
  | '2_letters'
  | '3_letters'
  | '4_letters'
  | '5_letters'
  | '6_letters'
  | '7_letters'
  | '8_letters'
  | '9_letters'
  | '10+_letters'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsLengthItem = {
  '1_letters': '1_letters' as NfdAnalyticsLengthItem,
  '2_letters': '2_letters' as NfdAnalyticsLengthItem,
  '3_letters': '3_letters' as NfdAnalyticsLengthItem,
  '4_letters': '4_letters' as NfdAnalyticsLengthItem,
  '5_letters': '5_letters' as NfdAnalyticsLengthItem,
  '6_letters': '6_letters' as NfdAnalyticsLengthItem,
  '7_letters': '7_letters' as NfdAnalyticsLengthItem,
  '8_letters': '8_letters' as NfdAnalyticsLengthItem,
  '9_letters': '9_letters' as NfdAnalyticsLengthItem,
  '10_letters': '10+_letters' as NfdAnalyticsLengthItem
}

export type NfdAnalyticsStateItem = 'minting' | 'forSale' | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsStateItem = {
  minting: 'minting' as NfdAnalyticsStateItem,
  forSale: 'forSale' as NfdAnalyticsStateItem,
  owned: 'owned' as NfdAnalyticsStateItem
}

export type NfdAnalyticsSaleTypeItem = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsSaleTypeItem = {
  auction: 'auction' as NfdAnalyticsSaleTypeItem,
  buyItNow: 'buyItNow' as NfdAnalyticsSaleTypeItem
}

export type NfdAnalyticsCategoryItem = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsCategoryItem = {
  curated: 'curated' as NfdAnalyticsCategoryItem,
  premium: 'premium' as NfdAnalyticsCategoryItem,
  common: 'common' as NfdAnalyticsCategoryItem
}

export type NfdAnalyticsEventItem =
  | 'minted'
  | 'offeredForSale'
  | 'canceledSale'
  | 'sold'
  | 'postedOffer'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdAnalyticsEventItem = {
  minted: 'minted' as NfdAnalyticsEventItem,
  offeredForSale: 'offeredForSale' as NfdAnalyticsEventItem,
  canceledSale: 'canceledSale' as NfdAnalyticsEventItem,
  sold: 'sold' as NfdAnalyticsEventItem,
  postedOffer: 'postedOffer' as NfdAnalyticsEventItem
}

export type NfdAnalyticsParams = {
  name?: string
  buyer?: string
  seller?: string
  event?: NfdAnalyticsEventItem[]
  requireBuyer?: boolean
  category?: NfdAnalyticsCategoryItem[]
  saleType?: NfdAnalyticsSaleTypeItem[]
  state?: NfdAnalyticsStateItem[]
  length?: NfdAnalyticsLengthItem[]
  traits?: NfdAnalyticsTraitsItem[]
  minPrice?: number
  maxPrice?: number
  afterTime?: string
  limit?: number
  offset?: number
  sort?: NfdAnalyticsSort
}

export type NfdGetNFDsForAddressesView = 'tiny' | 'thumbnail' | 'brief' | 'full'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdGetNFDsForAddressesView = {
  tiny: 'tiny' as NfdGetNFDsForAddressesView,
  thumbnail: 'thumbnail' as NfdGetNFDsForAddressesView,
  brief: 'brief' as NfdGetNFDsForAddressesView,
  full: 'full' as NfdGetNFDsForAddressesView
}

export type NfdGetNFDsForAddressesParams = {
  address: string[]
  limit?: number
  view?: NfdGetNFDsForAddressesView
}

export type NfdActivitySort = 'timeDesc'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdActivitySort = {
  timeDesc: 'timeDesc' as NfdActivitySort
}

export type NfdActivityType = 'changes'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdActivityType = {
  changes: 'changes' as NfdActivityType
}

export type NfdActivityParams = {
  name: string[]
  type?: NfdActivityType
  afterTime?: string
  limit?: number
  sort?: NfdActivitySort
}

export type NfdGetNFDView = 'tiny' | 'brief' | 'full'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdGetNFDView = {
  tiny: 'tiny' as NfdGetNFDView,
  brief: 'brief' as NfdGetNFDView,
  full: 'full' as NfdGetNFDView
}

export type NfdGetNFDParams = { view?: NfdGetNFDView; poll?: boolean; nocache?: boolean }

export type NfdSearchView = 'tiny' | 'thumbnail' | 'brief' | 'full'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdSearchView = {
  tiny: 'tiny' as NfdSearchView,
  thumbnail: 'thumbnail' as NfdSearchView,
  brief: 'brief' as NfdSearchView,
  full: 'full' as NfdSearchView
}

export type NfdSearchParams = {
  owner?: string
  reservedFor?: string
  prefix?: string
  substring?: string
  requireAddresses?: boolean
  limit?: number
  view?: NfdSearchView
}

export interface VersionResponseBody {
  appVersion: string
  contractVersion: string
}

/**
 * Data to use as part of verification
 */
export interface VerifyRequestResponseBody {
  /** Challenge to be used as part of verification process, with use specific to each field */
  challenge: string
  /** ID of challenge, must be used in subsequent confirmation call but may be blank */
  id: string
  /** If set, no confirmation is required, the verify call was sufficient */
  validated?: boolean
}

/**
 * User defined field name to verify
 */
export type VerifyRequestRequestBodyFieldToVerify =
  | 'twitter'
  | 'domain'
  | 'email'
  | 'avatar'
  | 'banner'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifyRequestRequestBodyFieldToVerify = {
  twitter: 'twitter' as VerifyRequestRequestBodyFieldToVerify,
  domain: 'domain' as VerifyRequestRequestBodyFieldToVerify,
  email: 'email' as VerifyRequestRequestBodyFieldToVerify,
  avatar: 'avatar' as VerifyRequestRequestBodyFieldToVerify,
  banner: 'banner' as VerifyRequestRequestBodyFieldToVerify
}

export interface VerifyRequestRequestBody {
  /** User defined field name to verify */
  fieldToVerify: VerifyRequestRequestBodyFieldToVerify
  name: string
  /** Sender of transaction - needs to be owner of NFD */
  sender: string
}

/**
 * Whether verification was successful
 */
export interface VerifyConfirmResponseBody {
  confirmed: boolean
}

export interface VerifyConfirmRequestBody {
  /** Challenge value, optional depending on verification type */
  challenge?: string
}

export interface UpdatePartialRequestBody {
  properties: NFDProperties
  /** Address that will be signing the returned transactions.  Should be owner of NFD */
  sender: string
}

export interface TotalsOKResponseBody {
  forSale: number
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  total: number
}

export interface RescindOfferRequestBody {
  /** Sender of transaction - needs to be owner of NFD */
  sender: string
}

export interface RateLimited {
  limit: number
  secsRemaining: number
}

export interface PurchaseRequestBody {
  buyer: string
  /** Amount in microAlgo to purchase/claim the NFD for */
  offer: number
}

export interface PostOfferToOwnerRequestBody {
  /** Note to pass along to the NFD owner.  Must be provided but can be blank */
  note: string
  /** Amount in microAlgo being offered to the NFD owner */
  offer: number
  sender: string
}

export interface OfferRequestBody {
  /** Amount in microAlgo to sell the NFD for.  1 ALGO is 1,000,000 microAlgo. 1 ALGO minimum, 100 million maximum. */
  offer: number
  reservedFor?: string
  /** Sender of transaction - needs to be owner of NFD */
  sender: string
}

/**
 * NfdRecordCollection is the result type for an array of NfdRecord (tiny view)
 */
export type NfdRecordTinyCollection = GetNFDOKResponseBodyTiny[]

/**
 * NfdRecordCollection is the result type for an array of NfdRecord (thumbnail view)
 */
export type NfdRecordThumbnailCollection = GetNFDOKResponseBodyThumbnail[]

/**
 * NfdRecordCollection is the result type for an array of NfdRecord (full view)
 */
export type NfdRecordFullCollection = GetNFDOKResponseBodyFull[]

/**
 * NfdRecordCollection is the result type for an array of NfdRecord (brief view)
 */
export type NfdRecordBriefCollection = GetNFDOKResponseBodyBrief[]

export type NfdRecordState = 'available' | 'minting' | 'reserved' | 'forSale' | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdRecordState = {
  available: 'available' as NfdRecordState,
  minting: 'minting' as NfdRecordState,
  reserved: 'reserved' as NfdRecordState,
  forSale: 'forSale' as NfdRecordState,
  owned: 'owned' as NfdRecordState
}

export type NfdRecordSaleType = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdRecordSaleType = {
  auction: 'auction' as NfdRecordSaleType,
  buyItNow: 'buyItNow' as NfdRecordSaleType
}

export type NfdRecordCategory = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NfdRecordCategory = {
  curated: 'curated' as NfdRecordCategory,
  premium: 'premium' as NfdRecordCategory,
  common: 'common' as NfdRecordCategory
}

export interface NfdRecord {
  /** NFD Application ID */
  appID?: number
  /** NFD ASA ID */
  asaID?: number
  /** Verified Algorand addresses for this NFD */
  caAlgo?: string[]
  category?: NfdRecordCategory
  /** Round this data was last fetched from */
  currentAsOfBlock?: number
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  /** Tags set by the system for tracking/analytics */
  metaTags?: string[]
  name: string
  nfdAccount?: string
  /** Owner of NFD */
  owner?: string
  properties?: NFDProperties
  /** Reserved owner of NFD */
  reservedFor?: string
  saleType?: NfdRecordSaleType
  /** amount NFD is being sold for (microAlgos) */
  sellAmount?: number
  /** Recipient of NFD sales */
  seller?: string
  sigNameAddress?: string
  state?: NfdRecordState
  /** Tags assigned to this NFD */
  tags?: string[]
  timeChanged?: string
  timeCreated?: string
  timePurchased?: string
  /** Unverified Algorand addresses for this NFD */
  unverifiedCaAlgo?: string[]
}

export type NfdRecordCollection = NfdRecord[]

/**
 * Verified properties
 */
export type NFDPropertiesVerified = { [key: string]: string }

/**
 * User properties
 */
export type NFDPropertiesUserDefined = { [key: string]: string }

/**
 * Internal properties
 */
export type NFDPropertiesInternal = { [key: string]: string }

/**
 * NFDProperties contains the expanded metadata stored within an NFD contracts' global-state
 */
export interface NFDProperties {
  /** Internal properties */
  internal?: NFDPropertiesInternal
  /** User properties */
  userDefined?: NFDPropertiesUserDefined
  /** Verified properties */
  verified?: NFDPropertiesVerified
}

export interface NFDAuction {
  /** Price in microAlgos */
  ceilingPrice: number
  /** Price in microAlgos */
  currentPrice?: number
  endTime: string
  /** Price in microAlgos */
  floorPrice: number
  name: string
  startTime: string
}

export interface NFDAuctionAndPrice {
  auctionInfo: NFDAuction
  /** Change in price per minute */
  changePerMinute?: number
  /** Minutes elapsed so far in Auction */
  elapsedMinutes?: number
  /** Current price in microAlgos */
  price?: number
  /** Total number of minutes in Auction */
  totalMinutes?: number
}

/**
 * NFDAnalyticRecord is an NFD Analytics record in a time-series collection, with timestamp, price, and event data for that point in time.
 */
export interface NFDAnalyticRecord {
  data?: NFDAnalyticEvent
  /** price of event in microAlgos */
  price?: number
  timestamp?: string
}

export interface NFDAnalyticRecords {
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  results: NFDAnalyticRecord[]
  /** total number of results, with data containing paged amount based on offset/limit */
  total: number
}

export type NFDAnalyticEventSaleType = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NFDAnalyticEventSaleType = {
  auction: 'auction' as NFDAnalyticEventSaleType,
  buyItNow: 'buyItNow' as NFDAnalyticEventSaleType
}

export type NFDAnalyticEventEvent =
  | 'minted'
  | 'offeredForSale'
  | 'canceledSale'
  | 'sold'
  | 'postedOffer'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NFDAnalyticEventEvent = {
  minted: 'minted' as NFDAnalyticEventEvent,
  offeredForSale: 'offeredForSale' as NFDAnalyticEventEvent,
  canceledSale: 'canceledSale' as NFDAnalyticEventEvent,
  sold: 'sold' as NFDAnalyticEventEvent,
  postedOffer: 'postedOffer' as NFDAnalyticEventEvent
}

export type NFDAnalyticEventCategory = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NFDAnalyticEventCategory = {
  curated: 'curated' as NFDAnalyticEventCategory,
  premium: 'premium' as NFDAnalyticEventCategory,
  common: 'common' as NFDAnalyticEventCategory
}

/**
 * NFDAnalyticEvent contains a price history record for a point in time of an NFD
 */
export interface NFDAnalyticEvent {
  block?: number
  buyer?: string
  category?: NFDAnalyticEventCategory
  event?: NFDAnalyticEventEvent
  groupID?: string
  metaTags?: string[]
  /** NFD Name */
  name?: string
  note?: string
  saleType?: NFDAnalyticEventSaleType
  seller?: string
}

/**
 * Changed properties
 */
export type NFDActivityChanges = { [key: string]: string }

/**
 * NFDActivity contains the property changes made in a particular NFD contract update call
 */
export interface NFDActivity {
  /** Algorand Block number of change */
  block: number
  'cache-control'?: string
  /** Changed properties */
  changes?: NFDActivityChanges
  etag?: string
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  /** NFD Name */
  name: string
  timeChanged: string
}

export interface KickoffRequestBody {
  buyer: string
  name: string
}

/**
 * Whether NFD App ID is for authentic NFD
 */
export interface IsValidNFDResponseBody {
  isValid: boolean
  message: string
  name: string
  sigNameAddress: string
}

/**
 * GetNFDOKResponseBody result type (tiny view)
 */
export interface GetNFDOKResponseBodyTiny {
  /** Verified Algorand addresses for this NFD */
  caAlgo?: string[]
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  name: string
  properties?: NFDProperties
  /** Unverified Algorand addresses for this NFD */
  unverifiedCaAlgo?: string[]
}

export type GetNFDOKResponseBodyThumbnailState =
  | 'available'
  | 'minting'
  | 'reserved'
  | 'forSale'
  | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyThumbnailState = {
  available: 'available' as GetNFDOKResponseBodyThumbnailState,
  minting: 'minting' as GetNFDOKResponseBodyThumbnailState,
  reserved: 'reserved' as GetNFDOKResponseBodyThumbnailState,
  forSale: 'forSale' as GetNFDOKResponseBodyThumbnailState,
  owned: 'owned' as GetNFDOKResponseBodyThumbnailState
}

/**
 * GetNFDOKResponseBody result type (thumbnail view)
 */
export interface GetNFDOKResponseBodyThumbnail {
  /** NFD Application ID */
  appID?: number
  /** Verified Algorand addresses for this NFD */
  caAlgo?: string[]
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  name: string
  /** Owner of NFD */
  owner?: string
  properties?: NFDProperties
  state?: GetNFDOKResponseBodyThumbnailState
  /** Unverified Algorand addresses for this NFD */
  unverifiedCaAlgo?: string[]
}

export type GetNFDOKResponseBodyFullState =
  | 'available'
  | 'minting'
  | 'reserved'
  | 'forSale'
  | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyFullState = {
  available: 'available' as GetNFDOKResponseBodyFullState,
  minting: 'minting' as GetNFDOKResponseBodyFullState,
  reserved: 'reserved' as GetNFDOKResponseBodyFullState,
  forSale: 'forSale' as GetNFDOKResponseBodyFullState,
  owned: 'owned' as GetNFDOKResponseBodyFullState
}

export type GetNFDOKResponseBodyFullSaleType = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyFullSaleType = {
  auction: 'auction' as GetNFDOKResponseBodyFullSaleType,
  buyItNow: 'buyItNow' as GetNFDOKResponseBodyFullSaleType
}

export type GetNFDOKResponseBodyFullCategory = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyFullCategory = {
  curated: 'curated' as GetNFDOKResponseBodyFullCategory,
  premium: 'premium' as GetNFDOKResponseBodyFullCategory,
  common: 'common' as GetNFDOKResponseBodyFullCategory
}

/**
 * GetNFDOKResponseBody result type (full view)
 */
export interface GetNFDOKResponseBodyFull {
  /** NFD Application ID */
  appID?: number
  /** NFD ASA ID */
  asaID?: number
  /** Verified Algorand addresses for this NFD */
  caAlgo?: string[]
  category?: GetNFDOKResponseBodyFullCategory
  /** Round this data was last fetched from */
  currentAsOfBlock?: number
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  /** Tags set by the system for tracking/analytics */
  metaTags?: string[]
  name: string
  nfdAccount?: string
  /** Owner of NFD */
  owner?: string
  properties?: NFDProperties
  /** Reserved owner of NFD */
  reservedFor?: string
  saleType?: GetNFDOKResponseBodyFullSaleType
  /** amount NFD is being sold for (microAlgos) */
  sellAmount?: number
  /** Recipient of NFD sales */
  seller?: string
  sigNameAddress?: string
  state?: GetNFDOKResponseBodyFullState
  /** Tags assigned to this NFD */
  tags?: string[]
  timeChanged?: string
  timeCreated?: string
  timePurchased?: string
  /** Unverified Algorand addresses for this NFD */
  unverifiedCaAlgo?: string[]
}

export type GetNFDOKResponseBodyBriefState =
  | 'available'
  | 'minting'
  | 'reserved'
  | 'forSale'
  | 'owned'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyBriefState = {
  available: 'available' as GetNFDOKResponseBodyBriefState,
  minting: 'minting' as GetNFDOKResponseBodyBriefState,
  reserved: 'reserved' as GetNFDOKResponseBodyBriefState,
  forSale: 'forSale' as GetNFDOKResponseBodyBriefState,
  owned: 'owned' as GetNFDOKResponseBodyBriefState
}

export type GetNFDOKResponseBodyBriefSaleType = 'auction' | 'buyItNow'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyBriefSaleType = {
  auction: 'auction' as GetNFDOKResponseBodyBriefSaleType,
  buyItNow: 'buyItNow' as GetNFDOKResponseBodyBriefSaleType
}

export type GetNFDOKResponseBodyBriefCategory = 'curated' | 'premium' | 'common'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNFDOKResponseBodyBriefCategory = {
  curated: 'curated' as GetNFDOKResponseBodyBriefCategory,
  premium: 'premium' as GetNFDOKResponseBodyBriefCategory,
  common: 'common' as GetNFDOKResponseBodyBriefCategory
}

/**
 * GetNFDOKResponseBody result type (brief view)
 */
export interface GetNFDOKResponseBodyBrief {
  /** NFD Application ID */
  appID?: number
  /** Verified Algorand addresses for this NFD */
  caAlgo?: string[]
  category?: GetNFDOKResponseBodyBriefCategory
  /** Not returned, used in tagging for response to indicate if-none-match etag matched */
  'match-check'?: string
  /** Tags set by the system for tracking/analytics */
  metaTags?: string[]
  name: string
  nfdAccount?: string
  /** Owner of NFD */
  owner?: string
  properties?: NFDProperties
  /** Reserved owner of NFD */
  reservedFor?: string
  saleType?: GetNFDOKResponseBodyBriefSaleType
  /** amount NFD is being sold for (microAlgos) */
  sellAmount?: number
  state?: GetNFDOKResponseBodyBriefState
  /** Unverified Algorand addresses for this NFD */
  unverifiedCaAlgo?: string[]
}

export interface Error {
  /** Is the error a server-side fault? */
  fault: boolean
  /** ID is a unique identifier for this particular occurrence of the problem. */
  id: string
  /** Message is a human-readable explanation specific to this occurrence of the problem. */
  message: string
  /** Name is the name of this class of errors. */
  name: string
  /** Is the error temporary? */
  temporary: boolean
  /** Is the error a timeout? */
  timeout: boolean
}

export interface ContractLockRequestBody {
  /** Whether to lock (true), or unlock (false) */
  lock: boolean
  /** Sender of transaction - needs to be owner of NFD */
  sender: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never

/**
 * YAML document containing the API swagger definition
 * @summary Download ./pubfiles/openapi3.yaml
 */
export const infoInfoOpenapi3Yaml = (options?: SecondParameter<typeof customAxios>) => {
  return customAxios<void>({ url: `/info/openapi3.yaml`, method: 'get' }, options)
}

/**
 * Returns version information for the service
 * @summary version info
 */
export const infoVersion = (options?: SecondParameter<typeof customAxios>) => {
  return customAxios<VersionResponseBody>({ url: `/info/version`, method: 'get' }, options)
}

/**
 * Find NFDs based on owner and/or reservations, or a prefix name search.  For typical 'reverse-lookup' functionality see the getNFDsForAddresses method (/nfd/address?....).  Fetching a specific NFD, use nfd/{name}.  Prefix search is useful for interactive lookups.
 * @summary Search for NFDs based on select lookup criteria
 */
export const nfdSearch = (
  params?: NfdSearchParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NfdRecordCollection>({ url: `/nfd`, method: 'get', params }, options)
}

/**
 * Get specific NFD if found
 * @summary get a specific NFD
 */
export const nfdGetNFD = (
  name: string,
  params?: NfdGetNFDParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NfdRecord | void>({ url: `/nfd/${name}`, method: 'get', params }, options)
}

/**
 * Fetch change activity for an NFD, specifically general 'block-level' deltas for an NFD
 * @summary activity nfd
 */
export const nfdActivity = (
  params?: NfdActivityParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NFDActivity[]>({ url: `/nfd/activity`, method: 'get', params }, options)
}

/**
 * Get all NFDs which have been explicitly linked to one or more verified [or unverified] Algorand address(es).  Unverified addresses will match but return as unverifiedCaAlgo array.  These should be treated specially and not have the same trust level as verified addresses as they can be falsely attributed.  The caAlgo array is what should be trust, caAlgo[0] is the deposit address for example. For reverse lookups returning multiple NFDs, take the first one matching in caAlgo array.
 * @summary reverse-address lookup
 */
export const nfdGetNFDsForAddresses = (
  params?: NfdGetNFDsForAddressesParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NfdRecordCollection>({ url: `/nfd/address`, method: 'get', params }, options)
}

/**
 * Fetch NFD analytics via various filters
 * @summary analytics nfd
 */
export const nfdAnalytics = (
  params?: NfdAnalyticsParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NFDAnalyticRecords>({ url: `/nfd/analytics`, method: 'get', params }, options)
}

/**
 * Get all open auctions or those open for a particular name
 * @summary getOpenAuctions nfd
 */
export const nfdGetOpenAuctions = (
  params?: NfdGetOpenAuctionsParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NFDAuctionAndPrice[]>({ url: `/nfd/auction`, method: 'get', params }, options)
}

/**
 * Browse NFDs via various filters
 * @summary browse nfd
 */
export const nfdBrowse = (
  params?: NfdBrowseParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NfdRecordCollection>({ url: `/nfd/browse`, method: 'get', params }, options)
}

/**
 * Lock/Unlock an NFD contract - if locked, the contract can never being modified until unlocked again by the owner.
 * @summary contractLock nfd
 */
export const nfdContractLock = (
  name: string,
  contractLockRequestBody: ContractLockRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/contract/lock/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: contractLockRequestBody
    },
    options
  )
}

/**
 * Request upgrade of the contract on an NFD
 * @summary contractUpgrade nfd
 */
export const nfdContractUpgrade = (
  name: string,
  rescindOfferRequestBody: RescindOfferRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/contract/upgrade/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: rescindOfferRequestBody
    },
    options
  )
}

/**
 * Determines if specified NFD Application ID is authentic
 * @summary isValidNFD nfd
 */
export const nfdIsValidNFD = (appID: number, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<IsValidNFDResponseBody>(
    { url: `/nfd/isValid/${appID}`, method: 'get' },
    options
  )
}

/**
 * Kickoff NFD minting process, with user buying specified NFD (or kicking off auction) as appropriate.  Purchase price is set by TxnLab
 * @summary kickoff nfd
 */
export const nfdKickoff = (
  kickoffRequestBody: KickoffRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string | void>(
    {
      url: `/nfd/kickoff`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: kickoffRequestBody
    },
    options
  )
}

/**
 * Returns NameSig address for an NFD name
 * @summary getNameSig nfd
 */
export const nfdGetNameSig = (name: string, options?: SecondParameter<typeof customAxios>) => {
  return customAxios<string>({ url: `/nfd/nameSig/${name}`, method: 'get' }, options)
}

/**
 * Offer up an NFD for sale - specifying price and optionally an address it is reserved for.
 * @summary offer nfd
 */
export const nfdOffer = (
  name: string,
  offerRequestBody: OfferRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/offer/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: offerRequestBody
    },
    options
  )
}

/**
 * Post an offer to buy to the owner of an NFD, offering up a particular amount with optional note for them to consider
 * @summary postOfferToOwner nfd
 */
export const nfdPostOfferToOwner = (
  name: string,
  postOfferToOwnerRequestBody: PostOfferToOwnerRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/postOfferToOwner/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postOfferToOwnerRequestBody
    },
    options
  )
}

/**
 * Purchase an NFD for sale - specifying buyer (to sign transaction) and price
 * @summary purchase nfd
 */
export const nfdPurchase = (
  name: string,
  purchaseRequestBody: PurchaseRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/purchase/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: purchaseRequestBody
    },
    options
  )
}

/**
 * Rescind offer of sale. Claiming NFD back for self, and removing it for sale.
 * @summary rescindOffer nfd
 */
export const nfdRescindOffer = (
  name: string,
  rescindOfferRequestBody: RescindOfferRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/rescindOffer/${name}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: rescindOfferRequestBody
    },
    options
  )
}

/**
 * Returns RevAddress address for an NFD name
 * @summary getRevAddressSig nfd
 */
export const nfdGetRevAddressSig = (
  address: string,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>({ url: `/nfd/revAddressSig/${address}`, method: 'get' }, options)
}

/**
 * Suggest NFDs to purchase
 * @summary suggest nfd
 */
export const nfdSuggest = (
  name: string,
  params?: NfdSuggestParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<NfdRecordCollection>(
    { url: `/nfd/suggest/${name}`, method: 'get', params },
    options
  )
}

/**
 * Fetch NFD summary data - results subject to change in the future
 * @summary totals nfd
 */
export const nfdTotals = (options?: SecondParameter<typeof customAxios>) => {
  return customAxios<TotalsOKResponseBody>({ url: `/nfd/totals`, method: 'get' }, options)
}

/**
 * Set an attribute in an NFD on behalf of a particular sender (who must be the owner)
 * @summary updatePartial nfd
 */
export const nfdUpdatePartial = (
  name: string,
  updatePartialRequestBody: UpdatePartialRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/update/${name}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: updatePartialRequestBody
    },
    options
  )
}

/**
 * Replace all NFD user-settable attributes with those passed-in, removing, adding and replacing on behalf of a particular sender (who must be the owner).  Returns transaction group of transactions to sign
 * @summary updateAll nfd
 */
export const nfdUpdateAll = (
  name: string,
  updatePartialRequestBody: UpdatePartialRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    {
      url: `/nfd/update/${name}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updatePartialRequestBody
    },
    options
  )
}

/**
 * Update the avatar or banner image associated with an NFD by uploading new image content
 * @summary updateImage nfd
 */
export const nfdUpdateImage = (
  name: string,
  sender: string,
  which: 'avatar' | 'banner',
  params?: NfdUpdateImageParams,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<string>(
    { url: `/nfd/updateImage/${name}/${sender}/${which}`, method: 'post', params },
    options
  )
}

/**
 * Verify a particular piece of data on, or off-chain.  Each verification differs in its requirements
 * @summary verifyConfirm nfd
 */
export const nfdVerifyConfirm = (
  id: string,
  verifyConfirmRequestBody: VerifyConfirmRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<VerifyConfirmResponseBody>(
    {
      url: `/nfd/verify/confirm/${id}`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: verifyConfirmRequestBody
    },
    options
  )
}

/**
 * Request Verification for particular piece of data on, or off-chain.  Each verification differs in its requirements. Returns data to be used in challenge
 * @summary verifyRequest nfd
 */
export const nfdVerifyRequest = (
  verifyRequestRequestBody: VerifyRequestRequestBody,
  options?: SecondParameter<typeof customAxios>
) => {
  return customAxios<VerifyRequestResponseBody>(
    {
      url: `/nfd/verify/request`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: verifyRequestRequestBody
    },
    options
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any

export type InfoInfoOpenapi3YamlResult = NonNullable<AsyncReturnType<typeof infoInfoOpenapi3Yaml>>
export type InfoVersionResult = NonNullable<AsyncReturnType<typeof infoVersion>>
export type NfdSearchResult = NonNullable<AsyncReturnType<typeof nfdSearch>>
export type NfdGetNFDResult = NonNullable<AsyncReturnType<typeof nfdGetNFD>>
export type NfdActivityResult = NonNullable<AsyncReturnType<typeof nfdActivity>>
export type NfdGetNFDsForAddressesResult = NonNullable<
  AsyncReturnType<typeof nfdGetNFDsForAddresses>
>
export type NfdAnalyticsResult = NonNullable<AsyncReturnType<typeof nfdAnalytics>>
export type NfdGetOpenAuctionsResult = NonNullable<AsyncReturnType<typeof nfdGetOpenAuctions>>
export type NfdBrowseResult = NonNullable<AsyncReturnType<typeof nfdBrowse>>
export type NfdContractLockResult = NonNullable<AsyncReturnType<typeof nfdContractLock>>
export type NfdContractUpgradeResult = NonNullable<AsyncReturnType<typeof nfdContractUpgrade>>
export type NfdIsValidNFDResult = NonNullable<AsyncReturnType<typeof nfdIsValidNFD>>
export type NfdKickoffResult = NonNullable<AsyncReturnType<typeof nfdKickoff>>
export type NfdGetNameSigResult = NonNullable<AsyncReturnType<typeof nfdGetNameSig>>
export type NfdOfferResult = NonNullable<AsyncReturnType<typeof nfdOffer>>
export type NfdPostOfferToOwnerResult = NonNullable<AsyncReturnType<typeof nfdPostOfferToOwner>>
export type NfdPurchaseResult = NonNullable<AsyncReturnType<typeof nfdPurchase>>
export type NfdRescindOfferResult = NonNullable<AsyncReturnType<typeof nfdRescindOffer>>
export type NfdGetRevAddressSigResult = NonNullable<AsyncReturnType<typeof nfdGetRevAddressSig>>
export type NfdSuggestResult = NonNullable<AsyncReturnType<typeof nfdSuggest>>
export type NfdTotalsResult = NonNullable<AsyncReturnType<typeof nfdTotals>>
export type NfdUpdatePartialResult = NonNullable<AsyncReturnType<typeof nfdUpdatePartial>>
export type NfdUpdateAllResult = NonNullable<AsyncReturnType<typeof nfdUpdateAll>>
export type NfdUpdateImageResult = NonNullable<AsyncReturnType<typeof nfdUpdateImage>>
export type NfdVerifyConfirmResult = NonNullable<AsyncReturnType<typeof nfdVerifyConfirm>>
export type NfdVerifyRequestResult = NonNullable<AsyncReturnType<typeof nfdVerifyRequest>>
